/**
 * @generated SignedSource<<8dd8b595be7b11f68857407e75031e94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ChargeSelectPaymentMethodInput = {
  chargeId: string;
  clientMutationId?: string | null | undefined;
  paymentMethod: string;
};
export type ChargeSelectPaymentMethodMutation$variables = {
  input: ChargeSelectPaymentMethodInput;
};
export type ChargeSelectPaymentMethodMutation$data = {
  readonly ChargeSelectPaymentMethod: {
    readonly charge: {
      readonly availablePaymentMethods: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly id: string;
      readonly paymentMethodSelected: string | null | undefined;
    } | null | undefined;
    readonly error: string | null | undefined;
  } | null | undefined;
};
export type ChargeSelectPaymentMethodMutation = {
  response: ChargeSelectPaymentMethodMutation$data;
  variables: ChargeSelectPaymentMethodMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChargeSelectPaymentMethodPayload",
    "kind": "LinkedField",
    "name": "ChargeSelectPaymentMethod",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Charge",
        "kind": "LinkedField",
        "name": "charge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentMethodSelected",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availablePaymentMethods",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChargeSelectPaymentMethodMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChargeSelectPaymentMethodMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8212e2a39b2246ac734969927d7e4c35",
    "id": null,
    "metadata": {},
    "name": "ChargeSelectPaymentMethodMutation",
    "operationKind": "mutation",
    "text": "mutation ChargeSelectPaymentMethodMutation(\n  $input: ChargeSelectPaymentMethodInput!\n) {\n  ChargeSelectPaymentMethod(input: $input) {\n    error\n    charge {\n      id\n      paymentMethodSelected\n      availablePaymentMethods\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3dde205a55dfda02a46458497b6a7a5a";

export default node;
